import './linked-movement-line.scss'

import { defineComponent, PropType } from 'vue'

import { Movement, getTranslatedString } from '@skinsoft/types'
import { TrackingRoutes } from '@skinsoft/const'
import { movementSelectors } from "@skinsoft/selectors"
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { LINK_MOVEMENT_PAGE_NAVIGATE } from '../../../../events'

export const LinkedMovementLine = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        movement: { type: Object as PropType<Movement>, required: true }
    },
    template: require('./linked-movement-line.html'),
    computed: {
        title(): string {
            return getTranslatedString(
                movementSelectors.indexTitle(this.movement) ?? movementSelectors.title(this.movement),
                this.getAppLocale()
            )
        },

        identificationNumber(): string {
            // @ts-ignore
            return movementSelectors.inventaryNumber(this.movement)
        },
    },
    methods: {
        onLinkClicked() {
            this.$emit(LINK_MOVEMENT_PAGE_NAVIGATE)
            this.$router.push({name: TrackingRoutes.MOVEMENT, params: { id: this.movement.id }})
        },
    },
})
